import { render } from "./parkTavor.vue?vue&type=template&id=135f565a&scoped=true"
import script from "./parkTavor.vue?vue&type=script&lang=js"
export * from "./parkTavor.vue?vue&type=script&lang=js"

import "./parkTavor.vue?vue&type=style&index=0&id=135f565a&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135f565a"]])

export default __exports__